export const getAllFaqs = () => 'company/faqs/';
    
  